export default "__VITE_ASSET__DduDl8_d__"